import withStyles from 'react-jss'
import FlightPassengersDeleteOverview from './FlightPassengersDeleteOverview'
import styles from './FlightPassengersDeleteOverview.styles'

export default withStyles(styles)(FlightPassengersDeleteOverview)
